import { render, staticRenderFns } from "./RecommendEmailSync.vue?vue&type=template&id=4c5121ca&scoped=true&lang=pug"
import script from "./RecommendEmailSync.vue?vue&type=script&lang=js"
export * from "./RecommendEmailSync.vue?vue&type=script&lang=js"
import style0 from "./RecommendEmailSync.vue?vue&type=style&index=0&id=4c5121ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5121ca",
  null
  
)

export default component.exports